<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt         from "@/http/requests/auth/jwt/index.js"

export default {
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
  },
  async created() {
    // jwt
    jwt.init()

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    // Auth0
    try       { await this.$auth.renewTokens() }
    catch (e) { console.error(e) }

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>
<style>
/* .input-border input{
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
  border-radius: 5px !important; 
} */
/* .input-border input:disabled{
  border: 1px solid rgba(0, 0, 0, 0.8) !important;
  border-radius: 5px !important;
} */

.vs-input--input{
  color: rgb(0, 0, 0, 0.4) !important;
}

.vs-input--input.normal{
  border: 1px solid rgba(0, 0, 0, 0.6) !important;
}

.vs-input--input:disabled{
  color: black !important;
  font-weight: 200;
  border: 1px solid rgba(0, 0, 0, 0.9) !important;
}

.vs-input--input:disabled+.vs-input--placeholder {
  opacity: 0.9 !important;
  color: rgb(0, 0, 0, 0.5);
}

.vs-input--placeholder.normal{
  color: rgb(0, 0, 0, 0.5);
}

.vs__dropdown-toggle{
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
}

.v-select .vs__selected{
  color: rgb(0, 0, 0, 0.5) !important;
}


</style>
